import { OtpValidateUseCase } from '../../../application';

export default class OtpValidateService {
    constructor() {}

    async execute(event) {
        const request = await OtpValidateUseCase(event);

        return request;
    }
}
